// extracted by mini-css-extract-plugin
export default {"films":"card_films__GRCEc"};